var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgHudChevronLeft = function SvgHudChevronLeft(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#F2F6FF",
    strokeWidth: 2,
    d: "M10 4 6 8l4 4"
  })));
};
export default SvgHudChevronLeft;